export const getValueTransctionTypeTopUp = (value) => {
  return value === 'Alipay' ? 'exAlipay' : value
}